import 'swiper/css';
import 'swiper/css/pagination';
import Image from 'next/image';
import type { FC } from 'react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button, Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { IconGoLeft } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
const HomeV2Slider: FC = () => {
  const isLogin = useAppSelector(state => state.auth.isLoggedIn);
  return <Container className="homeSlider py-4 md:py-10 lg:py-16" data-sentry-element="Container" data-sentry-component="HomeV2Slider" data-sentry-source-file="HomeV2Slider.tsx">
      <Swiper spaceBetween={30} loop speed={400} autoplay={{
      delay: 5000,
      reverseDirection: true,
      waitForTransition: true
    }} pagination={{
      clickable: true,
      bulletClass: 'swiper-pagination-bullet swiper-pagination-slider  ',
      bulletActiveClass: '!bg-blueFour !w-6 !rounded-[8px]'
    }} modules={[Pagination, Autoplay]} className="mySwiper" data-sentry-element="Swiper" data-sentry-source-file="HomeV2Slider.tsx">
        <SwiperSlide data-sentry-element="SwiperSlide" data-sentry-source-file="HomeV2Slider.tsx">
          <div className="flex flex-col   items-center pb-6  sm:flex-row sm:items-stretch sm:pb-10   ">
            <div className="mb-6 flex flex-col justify-around gap-4 sm:mb-0 sm:w-[70%] sm:gap-0 lg:pl-24">
              <h2 className="text-2xl font-bold text-blueFour  sm:text-2xl md:text-4xl md:leading-[60px]  lg:text-5xl  lg:leading-[90px] ">
                با آی‌نو
                <br />
                از دبستان تا کنکور...
              </h2>
              <p className=" text-md font-semibold text-blueSix lg:text-xl">
                از اولین قدم یعنی یادگیری عمیق مفاهیم کتاب درسی تا موفقیت در امتحان‌های مدرسه، امتحان نهایی و آزمون‌های مهم
                مثل تیزهوشان و کنکور با ویدیوهای آموزشی، نکته و تست و حل تمرین در کنارتیم.
              </p>
              <div className="flex flex-col gap-4 md:flex-row ">
                <Button as="a" href={isLogin ? LINKS.GRADE : LINKS.AUTH.LOGIN} variant="shadow" color="orangeN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  شروع یادگیری
                </Button>
                <Button as="a" href={LINKS.GRADE} variant="shadow" color="blueN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  مشاهده ویدیوها
                </Button>
              </div>
            </div>
            <div className="mb-4 sm:mb-0">
              <Image priority width={500} height={500} src={`${FILE_BROWSER_URL}/img/slider/Slider_Home1.webp`} alt="slide-one" className=" sm:max-h-none" data-sentry-element="Image" data-sentry-source-file="HomeV2Slider.tsx" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide data-sentry-element="SwiperSlide" data-sentry-source-file="HomeV2Slider.tsx">
          <div className="flex flex-col   items-center pb-6 sm:flex-row  sm:items-stretch sm:pb-10   ">
            <div className="mb-6 flex flex-col justify-around gap-4 sm:mb-0 sm:w-[70%] sm:gap-0 lg:pl-24">
              <h2 className="text-2xl font-bold text-blueFour  sm:text-2xl md:text-4xl md:leading-[60px]  lg:text-5xl  xl:leading-[90px] ">
                شب امتحان و کنکور، دیگه نگرانی نداره!
              </h2>
              <p className=" text-md font-semibold text-blueSix lg:text-xl">
                برای پایه‌های دهم، یازدهم و دوازدهم ویدیوهای شب امتحان و آموزش‌های کنکور آماده‌ست. با بهترین معلم‌ها درس‌ها
                رو مرور کن و خیالت از امتحان نهایی و کنکور راحت باشه! فقط کافیه شروع کنی و ویدیوها رو ببینی.
              </p>
              <div className="flex flex-col gap-4 md:flex-row ">
                <Button as="a" href={isLogin ? LINKS.GRADE : LINKS.AUTH.LOGIN} variant="shadow" color="orangeN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  شروع یادگیری
                </Button>
                <Button as="a" href={LINKS.GRADE} variant="shadow" color="blueN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  مشاهده ویدیوها
                </Button>
              </div>
            </div>
            <div className="mb-4 sm:mb-0">
              <Image width={500} height={500} src={`${FILE_BROWSER_URL}/img/slider/Slider_Home3.webp`} alt="slide-two" className=" sm:max-h-none" data-sentry-element="Image" data-sentry-source-file="HomeV2Slider.tsx" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide data-sentry-element="SwiperSlide" data-sentry-source-file="HomeV2Slider.tsx">
          <div className="flex flex-col   items-center pb-6 sm:flex-row  sm:items-stretch sm:pb-10   ">
            <div className="mb-6 flex flex-col justify-around gap-4 sm:mb-0 sm:w-[70%] sm:gap-0 lg:pl-24">
              <h2 className="text-2xl font-bold text-blueFour  sm:text-2xl md:text-4xl md:leading-[60px]  lg:text-5xl  xl:leading-[90px] ">
                قبولی تیزهوشان؟ از الان آماده باش!
              </h2>
              <p className=" text-md font-semibold text-blueSix lg:text-xl">
                با ویدیوهای ویژه تیزهوشان، برای آزمون‌های ششم و نهم آماده شو. از تست‌های گذشته تا نکات مهم، همه چی رو با یه
                کلیک یاد بگیر. فقط ثبت‌نام کن و شروع به دیدن ویدیوها کن، موفقیت از اینجا شروع میشه!
              </p>
              <div className="flex flex-col gap-4 md:flex-row ">
                <Button as="a" href={isLogin ? LINKS.GRADE : LINKS.AUTH.LOGIN} variant="shadow" color="orangeN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  شروع یادگیری
                </Button>
                <Button as="a" href={LINKS.GRADE} variant="shadow" color="blueN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  مشاهده ویدیوها
                </Button>
              </div>
            </div>
            <div className="mb-4 sm:mb-0">
              <Image width={500} height={500} src={`${FILE_BROWSER_URL}/img/slider/Slider_Home4.webp`} alt="slide-three" className=" sm:max-h-none" data-sentry-element="Image" data-sentry-source-file="HomeV2Slider.tsx" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide data-sentry-element="SwiperSlide" data-sentry-source-file="HomeV2Slider.tsx">
          <div className="flex flex-col   items-center pb-6  sm:flex-row sm:items-stretch sm:pb-10   ">
            <div className="mb-6 flex flex-col justify-around gap-4 sm:mb-0 sm:w-[70%] sm:gap-0 lg:pl-24">
              <h2 className="text-2xl font-bold text-blueFour  sm:text-2xl md:text-4xl md:leading-[60px]  lg:text-5xl  lg:leading-[90px] ">
                فقط توی یه درس کمک <br />
                می‌خوای؟{' '}
              </h2>
              <p className=" text-md font-semibold text-blueSix lg:text-xl">
                ویدیوهای تک‌درس رو با تدریس بهترین معلم اون درس ببین و فقط و فقط روی همون درس تمرکز کن!{' '}
              </p>
              <div className="flex flex-col gap-4 md:flex-row ">
                <Button as="a" href="https://ino.school/store/?promo_name=store1403&promo_position=slider&promo_creative=deyversion&promo_code=ToH14031003v1" variant="shadow" color="orangeN" radius="medium" afterIcon={<IconGoLeft className="text-white" size="small" />} className="!justify-between !px-4 font-bold lg:!px-6" size="middle" data-sentry-element="Button" data-sentry-source-file="HomeV2Slider.tsx">
                  مشاهده فروشگاه تک درس
                </Button>
              </div>
            </div>
            <div className="mb-4 sm:mb-0">
              <Image priority width={500} height={500} src={`${FILE_BROWSER_URL}/img/slider/Slider_Home22.webp`} alt="slide-one" className=" sm:max-h-none" data-sentry-element="Image" data-sentry-source-file="HomeV2Slider.tsx" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </Container>;
};
export default HomeV2Slider;